import { logoGradient } from "./colors";

const banners = [
  `   ░███         ░██          ░██          ░████████             ░██          ░██     ░█░██████
  ░██░██                     ░██          ░██    ░██            ░██          ░██     ░██ ░██  
 ░██  ░██░██░███░██░██████░███████░███████░██    ░██░██    ░█░███████░███████░██     ░██ ░██  
░████████░███   ░█░██        ░██ ░██    ░█░████████ ░██    ░██  ░██ ░██    ░█░██     ░██ ░██  
░██    ░█░██    ░██░███████  ░██ ░██    ░█░██     ░█░██    ░██  ░██ ░████████░██     ░██ ░██  
░██    ░█░██    ░██      ░██ ░██ ░██    ░█░██     ░█░██   ░███  ░██ ░██       ░██   ░██  ░██  
░██    ░█░██    ░██░███████   ░███░███████░█████████ ░█████░██   ░███░███████  ░██████ ░██████
                                                           ░██                                
                                                     ░███████                                  `,
  ` ▗▄▖▗▄▄▖▗▄▄▄▖▗▄▄▗▄▄▄▗▄▖▗▄▄▗▖  ▗▗▄▄▄▗▄▄▄▖    ▗▖ ▗▗▄▄▄▖
▐▌ ▐▐▌ ▐▌ █ ▐▌    █▐▌ ▐▐▌ ▐▝▚▞▘  █ ▐▌       ▐▌ ▐▌ █  
▐▛▀▜▐▛▀▚▖ █  ▝▀▚▖ █▐▌ ▐▐▛▀▚▖▐▌   █ ▐▛▀▀▘    ▐▌ ▐▌ █  
▐▌ ▐▐▌ ▐▗▄█▄▗▄▄▞▘ █▝▚▄▞▐▙▄▞▘▐▌   █ ▐▙▄▄▖    ▝▚▄▞▗▄█▄▖`,
  `   _       _    _       ___      _         _   _ ___ 
  /_\\  _ _(_)__| |_ ___| _ )_  _| |_ ___  | | | |_ _|
 / _ \\| '_| (_-<  _/ _ \\ _ \\ || |  _/ -_) | |_| || | 
/_/ \\_\\_| |_/__/\\__\\___/___/\\_, |\\__\\___|  \\___/|___|
                            |__/                      `,
  ` _____                                                                               _____ 
( ___ )                                                                             ( ___ )
 |   |~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|   | 
 |   |     \\          _)        |           __ )          |               |   | _ _| |   | 
 |   |    _ \\     __|  |   __|  __|   _ \\   __ \\   |   |  __|   _ \\       |   |   |  |   | 
 |   |   ___ \\   |     | \\__ \\  |    (   |  |   |  |   |  |     __/       |   |   |  |   | 
 |   | _/    _\\ _|    _| ____/ \\__| \\___/  ____/  \\__, | \\__| \\___|      \\___/  ___| |   | 
 |   |                                            ____/                              |   | 
 |___|~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|___| 
(_____)                                                                             (_____)`,
  `    \\          _)        |           __ )          |               |   | _ _|
   _ \\     __|  |   __|  __|   _ \\   __ \\   |   |  __|   _ \\       |   |   | 
  ___ \\   |     | \\__ \\  |    (   |  |   |  |   |  |     __/       |   |   | 
_/    _\\ _|    _| ____/ \\__| \\___/  ____/  \\__, | \\__| \\___|      \\___/  ___|
                                           ____/                             `,
  `    ___         _      __        ____        __          __  ______
   /   |  _____(______/ /_____  / __ )__  __/ /____     / / / /  _/
  / /| | / ___/ / ___/ __/ __ \\/ __  / / / / __/ _ \\   / / / // /  
 / ___ |/ /  / (__  / /_/ /_/ / /_/ / /_/ / /_/  __/  / /_/ _/ /   
/_/  |_/_/  /_/____/\\__/\\____/_____/\\__, /\\__/\\___/   \\____/___/   
                                   /____/                           `,
  `                ██                                                                      
   ▒██▒         ██                      ██████▒                          ██    ███████  
   ▓██▓         ██           ██         ███████▓        ██               ██    ███████  
   ████                      ██         ██   ▒██        ██               ██    ██ ██    
   ████ ██░███████   ▒████████████░████░██    ███▓  ▓████████░████▒      ██    ██ ██    
  ▒█▓▓█▒██████████  █████████████░████████   ▒█▒██  ████████░██████▒     ██    ██ ██    
  ▓█▒▒█▓███░    ██  ██▒  ░▒█ ██  ███  █████████░██▒ ██░ ██  ██▒  ▒██     ██    ██ ██    
  ██  ████      ██  █████▓░  ██  ██░  ░████████░███▒██  ██  ████████     ██    ██ ██    
  ████████      ██  ░██████▒ ██  ██    ███   ▒██░██▓█▓  ██  ████████     ██    ██ ██    
 ░████████      ██     ░▒▓██ ██  ██░  ░███    ██ ████░  ██  ██           ██    ██ ██    
 ▒██  ████      ██  █▒░  ▒██ ██░ ███  ████   ▒██ ▒███   ██░ ███░  ▒█     ██▓  ▓██ ██    
 ███  ████   ███████████████ ████░██████████████  ██▓   ████░███████     ▒████████████  
 ██▒  ▒███   ███████░▓████▓  ░████░████░██████▓   ██░   ░████░█████▒      ▒████▒██████  
                                                 ▒██                                    
                                                ███▒                                    
                                                ███                                     `,
];

export function getBanner() {
  return logoGradient(banners[0]);
}
